import React, { useEffect, useCallback, useState} from 'react';
import CycleAnalyzer from "components/zobject/custom/CycleAnalyzer.js";
import TidalEffectComponent from "components/effects/TidalEffectComponent.js";
import {connect} from 'react-redux';

const ZTidal = ({tidal, zobject}) => { 
    if (!tidal) {
        return '';
    }
    return (
        <div className="z-tidal">
          <TidalEffectComponent noUI={true} effect={tidal} sequencerEngine={zobject.sequencerEngine}/>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZTidal);
